import React from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { Link } from 'react-router-dom';

import breakpoints from '../../util/breakpoints';
import { Katy, Nico } from './Person';

const Wrapper = styled.div`

  margin-top: 250px;

  ${breakpoints.sm`
    margin-top: 180px;
  `}

  ${breakpoints.md`
    padding-top: 40px;
    margin-top: 130px;
  `}
`;

const CenteredCol = styled(Col)`
  text-align: center;
`;

const H2 = styled.h2`
  text-align: center;
`;

const Text = styled.span`
  display: inline;
  font-size: 1em;
  color: white;
  font-weight: 700;
  text-align: center;
  background-color: #1D1F35;
  line-height: 1.4em;

  ${breakpoints.sm`
    font-size: 1.1em;
  `}

  ${breakpoints.lg`
    font-size: 1.2em;
  `}

  ${breakpoints.xl`
    font-size: 1.5em;
  `}
`;

const Design = styled.span`
  color: #3372D7;
`;

const Code = styled.span`
  color: #ff02fd;
`;

const Button = styled(Link)`
  background-color: #89E7C6;
  color: #1D1F35;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.7em;
  letter-spacing: 0.2em;
  padding: 18px 40px;
  display: inline-block;
  margin-top: 25px;
  cursor: pointer;

  transition: filter 0.5s;

  &:hover {
    filter: brightness(120%);
    color: #1D1F35;
    text-decoration: none;
  }
`;

const HomeHero = () => (
  <Wrapper>

    <Katy src="/images/katy.svg" />
    <Nico src="/images/nico.svg" />

    <Container>
      <Row>
        <CenteredCol
          xs={{ size: 10, offset: 1 }}
          sm={{ size: 8, offset: 2 }}
          md={{ size: 6, offset: 3 }}
        >
          <H2><Text>we <Design>design</Design> &amp; <Code>code</Code><br />for the internet</Text></H2>
          <Button to="/work">see our work</Button>
        </CenteredCol>
      </Row>
    </Container>
  </Wrapper>
);

export default HomeHero;



// WEBPACK FOOTER //
// ./src/components/ui/HomeHero.js